import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./Renew.css";               // reuse the Renew styles
import useEscapeToGoBack from "../hooks/useEscapeToGoBack";

const API = "https://www.lianfoong.com/api/pawn-transactions";

export default function CancelLost() {
  useEscapeToGoBack();

  const [mmyy, setMmyy] = useState("");
  const [receiptNo, setReceiptNo] = useState("");  // last 1–4 digits
  const [tx, setTx] = useState(null);
  const [err, setErr] = useState("");

  const mRef = useRef(null);
  const rRef = useRef(null);
  const actionRef = useRef(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      mRef.current?.focus();
      mRef.current?.select?.();
    });
  }, []);

  const cleanMMYY   = (v) => v.replace(/\D/g, "").slice(0, 4);
  const cleanDigits = (v) => v.replace(/\D/g, "").slice(0, 4);

  const search = async () => {
    setErr(""); setTx(null);
    const mm = cleanMMYY(mmyy);
    const rn = cleanDigits(receiptNo);
    if (mm.length !== 4 || rn.length === 0) {
      setErr("Enter MMYY and last receipt digits."); return;
    }
    try {
      // ✅ uses your existing /search (unchanged)
      const r = await axios.get(`${API}/search`, { params: { mmyy: mm, receiptNo: rn }});
      setTx(r.data);
      requestAnimationFrame(() => actionRef.current?.focus());
    } catch (e) {
      setErr(e.response?.data || "Transaction not found.");
    }
  };

  const cancelLost = async () => {
    if (!tx) return;
    if (!tx.reportLostDate) {
      alert("This ticket is not marked as LOST.");
      return;
    }
    if (!window.confirm(`Cancel LOST for ${tx.receiptNo}?`)) return;
    try {
      await axios.post(`${API}/lost/cancel`, { mmyy: cleanMMYY(mmyy), receiptNo: cleanDigits(receiptNo) });
      alert("Lost status cancelled.");
      setTx({ ...tx, reportLostDate: null });
      setReceiptNo("");
      requestAnimationFrame(() => rRef.current?.focus());
    } catch (e) {
      alert(e.response?.data || "Failed to cancel.");
    }
  };

  // Enter key flow
  const onMMYYKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      rRef.current?.focus();
      rRef.current?.select?.();
    }
  };
  const onReceiptKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (tx) cancelLost(); else search();
    }
  };

  const fmtDate = (s) => {
    const m = String(s||"").match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : "";
  };

  return (
    <div className="renew-container">{/* <-- same wrapper as Renew */}
      <h2 className="title">Cancel – Lost</h2>

      <div className="form-group">
        <label>Month/Year (MMYY):</label>
        <input
          ref={mRef}
          inputMode="numeric"
          maxLength={4}
          placeholder="e.g. 0425"
          value={mmyy}
          onChange={(e)=>setMmyy(cleanMMYY(e.target.value))}
          onKeyDown={onMMYYKeyDown}
        />
      </div>

      <div className="form-group">
        <label>Receipt Last Digits:</label>
        <input
          ref={rRef}
          inputMode="numeric"
          maxLength={4}
          placeholder="e.g. 0326"
          value={receiptNo}
          onChange={(e)=>setReceiptNo(cleanDigits(e.target.value))}
          onKeyDown={onReceiptKeyDown}
        />
      </div>

      <button className="search-btn" onClick={search}>Search</button>

      {err && <p className="error-message">{String(err)}</p>}

      {tx && (
        <div className="transaction-details">
          <div className="details-grid">
            <p><strong>Receipt:</strong> {tx.receiptNo}</p>
            <p><strong>Pawner:</strong> {tx.pawnerNirc || "-"}</p>
            <p><strong>Item:</strong> {tx.item}</p>
            <p><strong>Amount:</strong> ${Number(tx.amount||0).toFixed(2)}</p>
            <p><strong>Grant Date:</strong> {fmtDate(tx.grantDate)}</p>
            <p><strong>Lost Reported:</strong> {tx.reportLostDate ? fmtDate(tx.reportLostDate) : "—"}</p>
          </div>

          <button ref={actionRef} className="next-btn" onClick={cancelLost}>
            Cancel Lost
          </button>
        </div>
      )}
    </div>
  );
}
